import React from 'react'

export default function ExclamationIcon() {
  return (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.5625 20C16.0853 20 20.5625 15.5228 20.5625 10C20.5625 4.47715 16.0853 0 10.5625 0C5.03965 0 0.5625 4.47715 0.5625 10C0.5625 15.5228 5.03965 20 10.5625 20Z" fill="#F0B323"/>
    <path d="M11.7725 5.58854C11.7725 4.98736 11.2778 4.5 10.6675 4.5C10.0572 4.5 9.5625 4.98736 9.5625 5.58854V11.0312C9.5625 11.6324 10.0572 12.1198 10.6675 12.1198C11.2778 12.1198 11.7725 11.6324 11.7725 11.0312V5.58854Z" fill="white"/>
    <path d="M11.7725 14.2975C11.7725 13.6963 11.2778 13.209 10.6675 13.209C10.0572 13.209 9.5625 13.6963 9.5625 14.2975C9.5625 14.8987 10.0572 15.3861 10.6675 15.3861C11.2778 15.3861 11.7725 14.8987 11.7725 14.2975Z" fill="white"/>
    </svg>
    
  )
}
